<template>
    <LabelWrapper v-bind="commLabelProps" :label="widget.props.label" :required="widget.props.required" :verifyInfo="verifyInfo" :inline="inline">
        <component
            :is="widget.cid"
            :widget="widget"
            :value="value"
            :formvalue="formvalue"
            :verifyInfo="verifyInfo"
            :rules="rules"
            :validation="validation"
            @change="changeHandler($event)"
            @verify="verifyHandler($event)"
        />
    </LabelWrapper>
</template>

<script>
import LabelWrapper from "./LabelWrapper.vue";
import Form from "./Form.vue";
import TextInput from "./TextInput.vue";
import LinkTextInput from "./LinkTextInput.vue";
import List from "./List.vue";
import ISwitch from "./ISwitch.vue";
import LabelWithLine from "./LabelWithLine.vue";
import TimeSelectRange from "./TimeSelectRange.vue";
import RemoteSelect from "./RemoteSelect.vue";
import RadioGroup from "./RadioGroup.vue";
import DatePicker from "./DatePicket.vue";
import Select from "./Select.vue";
import MultiInputs from "./MultiInputs.vue";
import NumberInput from "./NumberInput.vue";
// import QuestionSelect from './QuestionSelect.vue';
// import UploadImg from './UploadImg.vue';
import CheckboxGroup from "./CheckboxGroup.vue";
import Elselector from "./Elselect.vue";
import CombinedSearch from "./CombinedSearch.vue";
import CompoundInput from "./CompoundInput.vue";
import CountButton from "./CountButton.vue";

export default {
    name: "CustomFormItem",
    components: {
        LabelWrapper,
        Form,
        TextInput,
        LinkTextInput,
        List,
        ISwitch,
        LabelWithLine,
        TimeSelectRange,
        RemoteSelect,
        RadioGroup,
        Select,
        DatePicker,
        MultiInputs,
        NumberInput,
        // QuestionSelect,
        // UploadImg,
        CheckboxGroup,
        Elselector,
        CombinedSearch,
        CompoundInput,
        CountButton
    },
    props: ["value", "widget", "labelProps", "verifyInfo", "rules", "validation", "formvalue", "inline"],
    computed: {
        commLabelProps() {
            return this.labelProps || {};
        }
    },
    methods: {
        changeHandler(newItemData) {
            this.$emit("change", newItemData);
        },
        verifyHandler(info) {
            this.$emit("verify", info);
        }
    }
};
</script>

<style></style>
